import { LoadingOutlined } from "@ant-design/icons";
import { ConfigProvider, Form, Input, Switch } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import m3_logo from "../assets/images/M3_Logo.svg";
import GradientButton from "../Components/Button/GradientButton";
import { loginUser, setIsAuthenticated } from "../slices/authSlice";
import toastMessage from "../utils/toastMessage";

function SignIn() {
  const Navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  // const [isConfirmModal, setIsConfirmModal] = useState(false);
  const userAllFormsDetails = useSelector(
    (state) => state.user.userAllFormsDetails
  );
  const basicInfoData = userAllFormsDetails.find(
    (data) => data.SK === "Profile#BasicInfo"
  );
  console.log("🚀 ~ SignIn ~ basicInfoData:", basicInfoData);
  const handleSignIn = (values) => {
    // console.log(values, " = signInValues");
    setLoading(true);
    dispatch(
      loginUser({
        username: values.email,
        password: values.password,
      })
    )
      .unwrap()
      .then((x) => {
        if (x.error) {
          toastMessage(x.error, "error");
        } else {
          console.log(x, "dataaaaaaaaaaaaaaaaa");

          toastMessage("Logged in successfully", "success");
          localStorage.setItem("username", values.email);
          localStorage.setItem("accessToken", `Bearer ${x.idToken}`);
          setIsAuthenticated(true);
          const data = {
            email: values.email,
            // name: x.name,
            sub: x.sub,
          };
          localStorage.setItem("userAttributes", JSON.stringify(data));

          window.location.href = "/";
          // Navigate("/");
          // localStorage.setItem("type", type);
          // dispatch(setUserType(type));
          // const decoded = jwtDecode(`Bearer ${x.idToken}`);
          // console.log(decoded, "decoded token");
          // const userAttributes = {
          //   name: decoded.name,
          //   sub: decoded.sub,
          // };
          // localStorage.setItem(
          //   "userAttributes",
          //   JSON.stringify(userAttributes)
          // );
          // localStorage.setItem("name", decoded.name);
          // localStorage.setItem("username", decoded.email);
          // dispatch(setuserAttributesReducer(userAttributes));
        }
      })
      .catch((err) => {
        console.log(err, "eroooroororor");
        toastMessage(err.response.data.message, "error");
        console.log(err.response.data.error, "error");
      })
      .finally(() => {
        setLoading(false);
      });
    // signInAws(values.email, values.password, (err, data) => {
    //   localStorage.setItem("username", values.email);
    //   if (err === "User is not confirmed.") {
    //     toastMessage(err, "info");
    //     AwsResetOtp(values.email, (err, msg) => {
    //       if (err) {
    //         toastMessage(err, "error");
    //       } else {
    //         toastMessage(msg, "success");
    //       }
    //     });
    //     setLoading(false);
    //     // setIsConfirmModal(true);
    //     Navigate("/verify-email");
    //   } else if (err) {
    //     toastMessage(err, "error");
    //     setLoading(false);
    //   } else {
    //     // console.log(data, " = handleSignIn:data");
    //     localStorage.setItem("userAttributes", JSON.stringify(data));
    //     setLoading(false);
    //     dispatch(setIsAuthenticated(true));
    //     dispatch(setuserAttributesReducer(data));
    //     // Navigate("/");
    //     window.location.href = "/";
    //   }
    // });
  };

  // if(isConfirmModal){
  //   return <OtpForgotPassword confirmEmail={true} href="/signin"
  //             confirmEmailMsg=""
  //           />
  // }

  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            colorBgContainer: "transparent",
            colorIcon: "white",
            colorIconHover: "white",
            colorTextPlaceholder: "#DADADA",
            colorText: "#000000",
          },
          Switch: {
            colorPrimaryHover:
              "linear-gradient(270deg, #E3302E 0%, #FF6B38 44.79%, #FFA380 100%)",
            colorPrimary:
              "linear-gradient(270deg, #E3302E 0%, #FF6B38 44.79%, #FFA380 100%)",
          },
        },
      }}
    >
      <div className="registerContainer bg-darkJungleGreen h-screen flex justify-center items-center text-white">
        <div className="m3_logo_register absolute top-10 left-16">
          <img src={m3_logo} />
        </div>
        <div className="bg-black shadow-signupBoxShadow px-10 py-5 rounded-2xl w-[494px]">
          <h1 className="font-bold bg-signupTextBg inline-block text-transparent bg-clip-text text-2xl">
            Sign In
          </h1>
          <p>Enter your email and password to sign in!</p>
          <Form
            form={form}
            className=" text-black"
            name="basic"
            labelCol={{
              span: 24,
            }}
            wrapperCol={{
              span: 24,
            }}
            initialValues={{ remember: true }}
            // onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
            autoComplete="off"
            onFinish={handleSignIn}
          >
            <Form.Item
              label="Email"
              name="email"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please enter your Email!",
                },
              ]}
            >
              <Input placeholder="mail@exemple.com" className="text-black" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please enter your Password!",
                },
              ]}
            >
              <Input.Password
                placeholder="Min. 8 characters"
                className="text-black"
              />
            </Form.Item>

            {/* <Form.Item
              name="remember"
              valuePropName="checked"
              wrapperCol={{ offset: 8, span: 16 }}
            >
              <Checkbox>Remember me</Checkbox>
            </Form.Item> */}

            <div className="flex justify-between">
              <div className="flex gap-3">
                <Form.Item label="" name="remember" style={{ color: "white" }}>
                  <Switch className="mb-2" />
                </Form.Item>
                <p className="text-MeduimGrey">Remember Me</p>
              </div>
              <a
                onClick={() => Navigate("/forgot-password")}
                className="bg-signupTextBg inline-block text-transparent bg-clip-text font-semibold"
              >
                Forget password?
              </a>
            </div>
            <Form.Item className="mb-0">
              <GradientButton
                className="bg-signupSubmitBtn flex items-center gap-x-4 justify-center w-full rounded-3xl"
                // type="primary"
                type="submit"
                disabled={loading}
              >
                <span>Sign In </span>
                {loading && (
                  <span>
                    <LoadingOutlined style={{ fontSize: 20, color: "white" }} />
                  </span>
                )}
              </GradientButton>
            </Form.Item>
          </Form>
          {/* <p className="mt-10 text-sm flex items-center">
            Not registered yet ?
            <span
              onClick={() => Navigate("/signup")}
              className="text-orange-gradient text-lg cursor-pointer ml-2 hover:text-orange2"
            >
              {" "}
              Create an Account
            </span>
          </p> */}
          {/* <Divider>or</Divider>
          <div className="flex flex-col gap-3">
            <Button
              className="p-5 rounded-3xl flex justify-center items-center border-none bg-darkJungleGreen text-white"
              icon={<Google_original />}
            >
              Sign in with Google
            </Button>
            <Button
              className="p-5 rounded-3xl flex justify-center items-center border-none bg-darkJungleGreen text-white"
              icon={<Linkedin_original />}
            >
              Sign in with LinkedIn
            </Button>
          </div> */}
        </div>
      </div>
    </ConfigProvider>
  );
}

export default SignIn;
